module.exports = __webpack_public_path__ + "img/s.af8d38b6.jpg";